module.exports = __webpack_public_path__ + "img/svg/whatsapp.e2fe046b44d46708282582d67f015a1a.svg";